module.exports = __webpack_public_path__ + "img/booker_merci.9417070c.png";